import { render } from "./profile.html?vue&type=template&id=7806c4f0&scoped=true&ts=true"
import script from "./profile.ts?vue&type=script&lang=ts"
export * from "./profile.ts?vue&type=script&lang=ts"

import "./profile.scss?vue&type=style&index=0&id=7806c4f0&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7806c4f0"]])

export default __exports__